var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsset1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e59U203AIH61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.488765 0 0 5.404616-452.436422-405.000067)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 7.685739,
    ry: 7.685739,
    transform: "translate(90.115286 82.621691)",
    fill: "#60646e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 7.685739,
    ry: 7.685739,
    transform: "translate(129.400907 82.621691)",
    fill: "#60646e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 7.685739,
    ry: 7.685739,
    transform: "translate(109.758097 102.690007)",
    fill: "#60646e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 7.685739,
    ry: 7.685739,
    transform: "translate(109.758097 82.621691)",
    fill: "#60646e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 7.685739,
    ry: 7.685739,
    transform: "translate(90.115286 122.758327)",
    fill: "#60646e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 7.685739,
    ry: 7.685739,
    transform: "translate(129.400907 122.758327)",
    fill: "#60646e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 17.417773,
    ry: 19.998074,
    transform: "matrix(.441216 0 0 0.384287 90.117503 102.689268)",
    fill: "#60646e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 17.417773,
    ry: 19.998074,
    transform: "matrix(.441216 0 0 0.384287 129.400168 102.689268)",
    fill: "#60646e",
    strokeWidth: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/asset1.082059a05aaf932383c77285d38291a0.svg";
export { ForwardRef as ReactComponent };